import {
  find,
  getFreeTextQuery,
  getInsurers,
  getPlansByInsurer,
  getPreferred as getPreferredProviders,
  sendOutcome,
  getAppConfig,
  fetchGeo,
  getCptsByCodes,
  supportedPersonCapabilites,
} from './actions';

export const logic = {
  find,
  sendOutcome,
  getFreeTextQuery,
  getPreferredProviders,
  getInsurers,
  getPlansByInsurer,
  getAppConfig,
  fetchGeo,
  getCptsByCodes,
  supportedPersonCapabilites,
};
